'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AdminKYCContent from './components/AdminKYCContent';

export default function AdminKYCPage() {
  return (
    <AppLayout activePath="/admin/kyc">
      <AdminKYCContent />
    </AppLayout>
  );
}
